// ─── WISHLIST PAGE ────────────────────────────────────────────────────────────
import { useNavigate } from 'react-router-dom';
import { useWishlist } from '../contexts/WishlistContext';
import { ProductCard, Spinner, EmptyState } from '../components/shared/index';

export function WishlistPage() {
  const { wishlist, loading } = useWishlist();
  const navigate = useNavigate();
  if (loading) return <Spinner size="lg" centered />;
  const products = wishlist.map(w => w.product).filter(Boolean);
  return (
    <div className="container section fade-in">
      <div className="page-header">
        <p className="eyebrow">Saved Items</p>
        <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 44, fontStyle: 'italic' }}>Your Wishlist</h1>
        <p className="text-muted mt-8">{products.length} item{products.length !== 1 ? 's' : ''} saved</p>
      </div>
      {products.length === 0 ? (
        <EmptyState icon="♡" title="Your wishlist is empty" message="Save outfits you love and come back to them anytime" action={() => navigate('/browse')} actionLabel="Browse Collection" />
      ) : (
        <div className="grid-4 gap-20">{products.map(p => <ProductCard key={p._id} product={p} />)}</div>
      )}
    </div>
  );
}